import { render, staticRenderFns } from "./TrainList.vue?vue&type=template&id=272c6640&scoped=true"
import script from "./TrainList.vue?vue&type=script&lang=js"
export * from "./TrainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c6640",
  null
  
)

export default component.exports